import { Button } from '@/components/ui/button';
import { DataTable } from '@/components/ui/data-table';
import { QuestionnaireTemplateDetailProps } from '@/types/questionnaire';
import { sectionColumns } from '../../QuestionnaireSections/components/SectionColumns';
import { CreateSectionModal } from '../../QuestionnaireSections/components/CreateSectionModal';
import { EditSectionModal } from '../../QuestionnaireSections/components/EditSectionModal';
import { useModal } from '@/contexts/ModalContext';
import { DeleteSectionDialog } from '../../QuestionnaireSections/components/DeleteSectionDialog';

export function TemplateDetails({
  templateDetails,
  isLoading,
  onEdit,
}: {
  templateDetails?: QuestionnaireTemplateDetailProps;
  isLoading: boolean;
  onEdit: () => void;
}) {
  const { openModal, closeModal } = useModal();
  if (isLoading) return <div>Loading...</div>;
  if (!templateDetails) return 'Select a template to view details';
  return (
    <>
      <div className="flex flex-col gap-4 w-full">
        <div className="flex justify-between items-start">
          <h1 className="text-xl font-bold">{templateDetails.title}</h1>
          <div className="flex gap-2">
            <Button size="sm" variant="outline" onClick={onEdit}>
              Edit
            </Button>
          </div>
        </div>
        <p className="text-muted-foreground text-sm">
          {templateDetails.description}
        </p>
        <div className="flex flex-col gap-6 mt-6">
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-semibold">
              Sections ({templateDetails.sections.length})
            </h3>
            <Button
              size={'sm'}
              onClick={() => {
                const modalId = openModal({
                  component: (
                    <CreateSectionModal
                      templateId={templateDetails.id}
                      onClose={() => closeModal(modalId)}
                    />
                  ),
                  heading: 'Edit Section',
                });
              }}
            >
              Create Section
            </Button>
          </div>
          <DataTable
            data={templateDetails.sections}
            columns={sectionColumns({
              templateId: templateDetails.id,
              onEdit: (section) => {
                const modalId = openModal({
                  component: (
                    <EditSectionModal
                      section={section}
                      allSections={templateDetails.sections}
                      onClose={() => closeModal(modalId)}
                    />
                  ),
                  heading: 'Edit Section',
                });
              },
              onDelete: (section) => {
                const modalId = openModal({
                  component: (
                    <DeleteSectionDialog
                      section={section}
                      onClose={() => closeModal(modalId)}
                      onSuccess={() => closeModal(modalId)}
                    />
                  ),
                  heading: 'Delete Section',
                });
              },
            })}
          />
        </div>
      </div>
    </>
  );
}
